import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import ServiceSidebar from '../ServiceSidebar/Main'
import qa1 from "../../../assets/images/services/qa-1-1.jpg";
import qa2 from "../../../assets/images/services/qa-1-2.jpg";
import { useTranslation } from 'react-i18next';

const QATesting = () => {
  const { t } = useTranslation();
  const [clicked, setClicked] = useState(0);

  const faqs = [
    {
      question: t('qa_testing.faq.mobile_testing_q'),
      answer: t('qa_testing.faq.mobile_testing_a'),
    },
    {
      question: t('qa_testing.faq.automation_testing_q'),
      answer: t('qa_testing.faq.automation_testing_a'),
    },
    {
      question: t('qa_testing.faq.manual_testing_q'),
      answer: t('qa_testing.faq.manual_testing_a'),
    },
    {
      question: t('qa_testing.faq.performance_testing_q'),
      answer: t('qa_testing.faq.performance_testing_a'),
    },
    {
      question: t('qa_testing.faq.data_testing_q'),
      answer: t('qa_testing.faq.data_testing_a'),
    },
    {
      question: t('qa_testing.faq.accessibility_testing_q'),
      answer: t('qa_testing.faq.accessibility_testing_a'),
    },
    {
      question: t('qa_testing.faq.elearning_testing_q'),
      answer: t('qa_testing.faq.elearning_testing_a'),
    },
    {
      question: t('qa_testing.faq.web_service_testing_q'),
      answer: t('qa_testing.faq.web_service_testing_a'),
    },
  ];

  return (
    <>
      <Breadcumb
        Title={t('breadcrumb.qa_testing')}
        Breadcumb={t('breadcrumb.services')}
      />

      <section className="section-padding--bottom section-padding--top service-details--page">
        <div className="container">
          <div className="row ">
            <div className="col-lg-8">
              <div className="service-details__image">
                <img src={qa1} alt="" />
              </div>

              <h3 className="service-details__title">
                {t('qa_testing.page_title')}
              </h3>

              <div className="service-details__content">
                <p>{t('qa_testing.intro_p')}</p>

                <h4>{t('qa_testing.sub_title')}</h4>

                <p>{t('qa_testing.sub_p')}</p>
              </div>

              <div className="row gutter-y-30 service-details__box-wrapper">
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-consulting"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">
                          {t('qa_testing.box1_title')}
                        </Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('qa_testing.box1_text')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-chip"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">
                          {t('qa_testing.box2_title')}
                        </Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('qa_testing.box2_text')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row gutter-y-30">
                <div className="col-md-6 col-sm-12">
                  <img
                    src={qa2}
                    className="service-details__sub-image"
                    alt=""
                  />
                </div>

                <div className="col-md-6 col-sm-12">
                  <div className="service-details__caption">
                    <h3 className="service-details__caption__title">
                      {t('qa_testing.benefits_title')}
                    </h3>
                    <p className="service-details__caption__text">
                      {t('qa_testing.benefits_subtitle')}
                    </p>

                    <ul className="service-details__caption__list">
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.mobile')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.automation')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.manual')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.performance')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.data')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.accessibility')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.elearning')}</li>
                      <li><i className="fa fa-check-circle"></i>{t('qa_testing.benefits.webservice')}</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div
                    className="accrodion-grp service-details__accrodion"
                    data-grp-name="service-details__accrodion-1"
                  >
                    {faqs.map((item, index) => (
                      <div
                        className={`accrodion wow fadeInUp ${
                          index === clicked && "active"
                        }`}
                        key={index}
                      >
                        <div className="accrodion-title">
                          <h4 onClick={() => setClicked(index)}>
                            {item.question}
                            <span className="accrodion-icon"></span>
                          </h4>
                        </div>

                        {index === clicked && (
                          <div className="accrodion-content">
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 sidebar-column">
              <ServiceSidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QATesting;
